<template>
  <div>
    <div class="chart-head-container">
      <h2>
        Miles Traveled by Day of the Week and Month
        <button v-tooltip title="Heat map of the data collected each month and day of the week" class="btn btn-tooltip ms-2"><font-awesome-icon icon="fa-solid fa-info-circle" /></button>
      </h2>
    </div>
    <highcharts class="hc col-12" :options="chartOptions" ref="chart"></highcharts>
  </div>

</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  chartData: Array,
});

function getPointCategoryName(point, dimension) {
  const { series } = point;
  const isY = dimension === 'y';
  const axis = series[isY ? 'yAxis' : 'xAxis'];
  return axis.categories[point[isY ? 'y' : 'x']];
}

const chartOptions = ref({
  chart: {
    type: 'heatmap',
    marginTop: 40,
    marginBottom: 80,
    plotBorderWidth: 1,
    backgroundColor: '#f5f5f5',
    style: {
      fontFamily: 'Roboto',
      fontSize: '14px,',
    },
  },
  title: { text: null },
  xAxis: {
    categories: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct', 'Nov.', 'Dec'],
    labels: {
      style: {
        fontSize: '15px',
      },
    },
  },

  yAxis: {
    categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    title: null,
    reversed: true,
    labels: {
      style: {
        fontSize: '15px',
      },
    },
  },
  accessibility: {
    point: {
      descriptionFormatter(point) {
        const ix = point.index + 1;
        const xName = getPointCategoryName(point, 'x');
        const yName = getPointCategoryName(point, 'y');
        const val = point.value;
        return `${ix}. ${xName} sales ${yName}, ${val}.`;
      },
    },
  },
  colorAxis: {
    min: 0,
    // maxColor: '#004F74',
    // minColor: '#A4E3FE',
    stops: [
      [0, '#A4E3FE'],
      [0.1, '#5BCBFC'],
      [0.2, '#24B8FC'],
      [0.3, '#0092D6'],
      [0.8, '#0072A7'],
      [1, '#004F74'],
    ],
  },

  legend: {
    align: 'right',
    layout: 'vertical',
    margin: 0,
    verticalAlign: 'top',
    y: 25,
    symbolHeight: 280,
    // itemStyle: {
    //     fontSize: '20px',
    // },
  },

  tooltip: {
    formatter() {
      return `Traveled <b>${this.point.value.toLocaleString()}</b> miles <br/> on ${getPointCategoryName(this.point, 'y')}s in ${getPointCategoryName(this.point, 'x')}`;
    },
  },
  series: [{
    name: 'Distance by mile',
    borderWidth: 1,
    borderColor: '#ffffff',
    data: props.chartData,
  }],
  navigation: {
    buttonOptions: {
      theme: {
        fill: '#f5f5f5',
      },
    },
  },

  responsive: {
    rules: [{
      condition: {
        maxWidth: 500,
      },
      chartOptions: {
        yAxis: {
          labels: {
            formatter() {
              return this.value.charAt(0);
            },
          },
        },
      },
    }],
  },

});

</script>
